import { useParams } from "react-router-dom";
import { useCompteLoginConfirmationMutation, useFetchCompteLoginActifQuery } from "../../../redux/slice/api/FO/compteApi";
import { toast } from "react-toastify";
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import { Button, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
// import img from "../../../images/image.svg"
import { MESSAGE_MOTDEPASSE } from "../../../data/message-infobulle";
import { PasswordSchema } from "../Utilisateur/PasswordSchema";
import { yupResolver } from "@hookform/resolvers/yup";

import keycloak from "../../../keycloak";
import { INewPassword } from "../../../models/interfaces/IPassword";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import { useEffect, useState } from "react";
import { ILoginReturn } from "../../../models/interfaces/ILoginReturn";
import CpntCommunicationBloc from "../components/communication/CpntCommunicationBloc";
import analytics from "../../../components/hooks/analytics";
import CheckboxInput from "../../../components/forms/CheckBoxInput";
import PasswordInput from "../../../components/forms/PasswordInput";
export type Param = {
  Code: string;
};

const PageCompteConfirmation: React.FC = () => {
  const { Code } = useParams<Param>();

  // Appeler tous les Hooks ici pour garantir qu'ils sont appelés de manière non conditionnelle
  //const history = useHistory();
  const [LoginConfirmation] = useCompteLoginConfirmationMutation();
  const [reponseConfirmation, setReponseConfirmation] = useState<ILoginReturn|null>(null);

  const { data: LoginResult,isLoading: LoginResultLoading } = useFetchCompteLoginActifQuery({Code:Code ?? ""}, {
    refetchOnMountOrArgChange: true,
    skip: !Code,
  });

  useEffect(() => {
    keycloak.authenticated && keycloak.logout();//au cas ou .
    //to test
    // !reponseConfirmation && setReponseConfirmation({
    //   Login: "",
    //   Return_IdType_Message:Type_Return_Message.Erreur
    // })
  }, [])


  // useEffect(() => {
  //   if (reponseConfirmation && reponseConfirmation.Return_IdType_Message === Type_Return_Message.Erreur) {
  //     reponseConfirmation.Return_Message &&
  //     toast.error(<div dangerouslySetInnerHTML={{ __html: reponseConfirmation.Return_Message }} />,{autoClose:5000});
  //   } else if (reponseConfirmation 
  //     && reponseConfirmation.Return_IdType_Message === Type_Return_Message.Validation 
  //     && reponseConfirmation.Login !== "") {
  //     // keycloak.login();
  //     //toast.success("Votre compte est confirmé",{autoClose:4000});

  //     // setTimeout(() => {
  //     //   navigate("/accueil"); 
  //     // }, 5000);
  //   }
  // }, [reponseConfirmation]) 

  const formMethods = useForm<INewPassword>({
    defaultValues: {
      NewPassword: "",
      ConfirmationPassword: "",
    },
    resolver: yupResolver(PasswordSchema),
    mode: "all",
    reValidateMode: "onBlur"
  });

  const {
    handleSubmit,
  } = formMethods;

  const onSubmit = async (data: any) => {
    try {
      const response = await LoginConfirmation({
        ...data,
        Code: Code
      }).unwrap();

        setReponseConfirmation(response);
        //dispatch(resetCompte());
    } catch (error) {
      toast.error("Erreur lors de la création du mot de passe")
    }
  };

  useEffect(() => {
    if (reponseConfirmation && reponseConfirmation?.Return_IdType_Message === Type_Return_Message.Validation ) {
      analytics.sendEvent("sign_up", {})
    }
  }, [reponseConfirmation])

  if (!Code || LoginResultLoading) {
    return <></>;
  }


  
  return (
    <>
    { reponseConfirmation || LoginResult?.Login ?
          <CpntCommunicationBloc
          HeaderColorClass={reponseConfirmation?.Return_IdType_Message === Type_Return_Message.Validation || LoginResult?.Login ? "bg-green" : "bg-red"}
          HeaderIconClass={
            reponseConfirmation?.Return_IdType_Message === Type_Return_Message.Validation || LoginResult?.Login ? "bi-trophy-fill" : undefined
          }
          Title={reponseConfirmation?.Return_IdType_Message === Type_Return_Message.Validation || LoginResult?.Login ? "Félicitations !" : "Attention !"}
          DescriptionIconClass={
            reponseConfirmation?.Return_IdType_Message === Type_Return_Message.Validation || LoginResult?.Login
              ? "bi-check-circle-fill fs-1 text-green"
              : "bi-x-circle-fill fs-1 text-redlight"
          }
          DescriptionHTML={
            reponseConfirmation?.Return_IdType_Message === Type_Return_Message.Validation || LoginResult?.Login ? (
              <>
                Votre compte a été créé avec succès ! <br />
                {/* Merci de vous authentifier en cliquant&nbsp;
                <Link className="pae-link" to="/accueil">
                  ici
                </Link> */}
              </>
            ) : (
              <>Une erreur s&apos;est produite, votre compte n&apos;est pas confirmé</>
            )
          }
        />
        : 
    <Row>
      <div className="container text-center">
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12">
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <CpntForm>
                  <CpntFormSection pSectionLabel="Définissez votre mot de passe">
                    <CpntFormSectionContainer
                      ColumnsSize={12}
                      ColumnsSizesMd={[12, 12]}
                    >
                        <PasswordInput
                                          formName="NewPassword"
                                          label="Mot de passe"
                                          popover={MESSAGE_MOTDEPASSE}
                                          isMandatory={true}
                                        />
                     <PasswordInput
                                          formName="ConfirmationPassword"
                                          label="Confirmation du mot de passe"
                                          popover={MESSAGE_MOTDEPASSE}
                                          isMandatory={true}
                      />
                      </CpntFormSectionContainer>
                      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12, 12]}>
                                    <CheckboxInput
                                      formName="RecevoirCommunications"
                                      label={`J'accepte de recevoir les communications du portail "${process.env.REACT_APP_WEBSITE_TITLE}"`}
                                      options={[
                                        {
                                          defaultChecked: false,
                                        },
                                      ]}
                                      labelRight={true}
                                    />
                                    <CheckboxInput
                                      formName="RecevoirCommunicationsPartenaires"
                                      label={`J'accepte de recevoir les communications des partenaires du portail "${process.env.REACT_APP_WEBSITE_TITLE}"`}
                                      options={[
                                        {
                                          defaultChecked: false,
                                        },
                                      ]}
                                      labelRight={true}
                                    />
                                  </CpntFormSectionContainer>
                    <CpntFormSectionNavigation>
                      <Button type="submit" className="btn-secondary col-12">
                        Valider
                      </Button>
                    </CpntFormSectionNavigation>
                  </CpntFormSection>
                </CpntForm>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </Row>
}
    </>
  );
};

export default PageCompteConfirmation;

